module.exports = __webpack_public_path__ + "mod_assets/_/_/_/modules/events/registration/client/js/form/tpls/fields/radiogroup.tpl.html";